<template>
	<div class="app-container">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'LOBCostsParent',
}
</script>

<style scoped>
.app-container {
	min-height: 100vh;
}
</style>
